import { dataProps, 
        itemListProps } from './properties'

export const setSaleDeliveryList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
        state.nav.had_results = payload.total>0
    }
}    

export const setSaleDeliveryData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }
    
    let key = 0
    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

} 

export const addNewSaleDeliveryItemListRow = state => {

    let key = 0
    state.props.item_list.push(JSON.parse(JSON.stringify(itemListProps)))

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('item_id_'+(key-1)).focus()
    }, 300);

}

export const removeSaleDeliveryItemListRow = (state, payload) => {

    let key = 0

    state.props.item_list.splice(payload, 1)

    if(state.props.item_list.length === 0) {
        state.props.item_list = [JSON.parse(JSON.stringify(itemListProps))]
    }

    state.props.item_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const setLoadReadyItemsForDelivery = (state, payload) => {

    let itemList = JSON.parse(JSON.stringify(payload))

    itemList = itemList.filter((thing, index, self) =>
        index === self.findIndex((t) => (t.id == thing.id))
    )

    state.props.item_list = []
    state.props.pending_list = []
    let key = 0
    itemList.forEach(element => {
        if(element.hidden_process>0 && element.current_store_id === element.store_id) {
            state.props.item_list.push({
                key: key,
                id: 0,
                selected: false,
                production_id: element.id,
                direct_delivery: false,
                item_detail: {
                    sale_number: element.sale_number,
                    work_order_number: element.work_order_number,
                    customer_name: element.customer_name,
                    sub_template_name: element.sub_template_name,
                    template_name: element.template_name,
                    process_name: element.process_name,
                    work_status: element.work_status,
                    hidden_process: element.hidden_process,
                    sale_date_changed: element.sale_date_changed,
                    sale_delivery_on_full_payment: element.sale_delivery_on_full_payment,
                    balance: element.balance,
                    fabric_details: element.sku_code+', '+element.article_name,
                    current_store_id: element.current_store_id,
                    sale_store_id: element.store_id
                }
            })
            key ++
        }
    })

    key = 0
    itemList.forEach(element => {
        if(element.hidden_process<0 || element.current_store_id !== element.store_id) {
            state.props.pending_list.push({
                key: key,
                id: 0,
                selected: false,
                production_id: element.id,
                direct_delivery: false,
                item_detail: {
                    sale_number: element.sale_number,
                    work_order_number: element.work_order_number,
                    customer_name: element.customer_name,
                    sub_template_name: element.sub_template_name,
                    template_name: element.template_name,
                    process_name: element.process_name,
                    work_status: element.work_status,
                    hidden_process: element.hidden_process,
                    sale_date_changed: element.sale_date_changed,
                    fabric_details: element.sku_code+', '+element.article_name
                }
            })
            key ++
        }
    })

}

export const resetSaleDeliveryData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}

export const setSaleDeliveryOTP = (state, payload) => {
    state.props.otp = payload
}


// WEBPACK FOOTER //
// ./src/store/modules/saleDelivery/mutations.js